import React from 'react';
import { Typography, Paper, Box } from '@mui/material';
import { Assessment } from '@mui/icons-material';

export default function ReceptionReports() {
  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>Rapoarte operaționale</Typography>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Assessment sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
        <Typography variant="h6" color="text.secondary">Programări, no-show, încasări, restante</Typography>
      </Paper>
    </Box>
  );
}
